module.exports = "<div class=\"tinymce-edit-component\">\n    <div class=\"{{uiContainer}}\" style=\"position: relative;\">\n        <div id=\"{{toolbarName}}\"></div>\n        <div id=\"{{name}}\" #editor [ngStyle]=\"{minHeight: height+'px',maxHeight: maxHeight+'px',overflow: 'auto'}\"></div>\n    </div>\n</div>\n<attachments [filesObj]=\"filesObj\" (attachmentsChanged)=\"emitNewAttachments($event)\"></attachments>\n<!--<job-files-modal></job-files-modal>-->\n\n\n"


//////////////////
// WEBPACK FOOTER
// ./web/modern/components/common/sn-tiny-editor/sn-tiny-editor.html
// module id = ./web/modern/components/common/sn-tiny-editor/sn-tiny-editor.html
// module chunks = 0